export enum ActionConstants {
	LOGIN = 'login',
	LOGOUT = 'logout',
	OPEN_SUCCESS = 'auth_success_open',
	CLOSE_SUCCESS = 'auth_success_close',
	UPDATE_USER_DATA = 'auth_update_user_data',
}
